import React from 'react';
import { ConvertStringToHtmlId } from '../../libs/ts/ConvertStringToHtmlId';

export interface props {
  title: string;
  description?: string;
  onSelected: (checked: boolean) => void;
  checked: boolean;
  group?: string;
  readonly?: boolean;
}

export const Checkbox = (props: props) => {
  const checkboxTitle = ConvertStringToHtmlId(props.title);

  const handleCheckboxSelected = React.useCallback(() => {
    if (props.readonly) return;
    return props.onSelected(!props.checked);
  }, [props]);

  return (
    <div>
      <div className="flex flex-row w-full" onClick={handleCheckboxSelected}>
        <input
          type="checkbox"
          id={checkboxTitle}
          name={props.group ?? props.title}
          value={checkboxTitle}
          checked={props.checked}
          onChange={handleCheckboxSelected}
          disabled={props.readonly}
          className="
            w-4 h-4 translate-y-1
            appearance-none
            bg-transparent
            border-2 border-secondary-deep-blue-30
            rounded-[2px]
            cursor-pointer
            relative

            hover:border-solid-bold-green
            checked:border-solid-bold-green
            checked:bg-solid-bold-green

            after:content-['']
            after:absolute
            after:hidden
            after:w-[4px]
            after:h-[8px]
            after:border-secondary-deep-blue-80
            after:border-r-2
            after:border-b-2
            after:rotate-45
            after:left-[5px]
            after:top-[1px]

            checked:after:block

            disabled:opacity-50
            disabled:cursor-not-allowed
          "
        />
        <label className="ml-7">{props.title}</label>
      </div>

      {props.description !== undefined && (
        <span
          className={`block whitespace-pre-wrap mt-3 mb-5 ml-8 mr-8 leading-6 text-sm text-secondary-deep-blue-20 font-italic overflow-hidden transition-[max-height] ease-in duration-300 max-h-0`}
        >
          {props.description}
        </span>
      )}
    </div>
  );
};
